<template>
    <div class="dinlineb">
        <el-tooltip v-if="!hasAccess" placement="top">
            <template #content>
                {{
                    $l10n.__(
                        "Vous n'avez pas les permissions nécessaires pour effectuer cette action.",
                    )
                }}
            </template>
            <a class="link pointer" :class="!hasAccess ? 'link-disabled' : ''">
                <slot />
            </a>
        </el-tooltip>

        <a v-else class="link pointer" @click="clicked">
            <slot />
        </a>
    </div>
</template>

<script>
export default {
    props: {
        permissions: {
            type: Object,
            required: false,
        },
        permToCheck: {
            type: String,
            required: false,
        },
    },
    data() {
        return {};
    },
    computed: {
        hasAccess() {
            return this.permissions ? this.permissions[this.permToCheck] : true;
        },
    },
    methods: {
        clicked() {
            if (this.hasAccess) {
                this.$emit('clicked');
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@use '~@sellsy/styleguide/src/_variables' as *;

.btn.btn-primary .link {
    color: $white !important;
}
</style>
